import React, { useContext, useEffect, useState } from "react"
import PropTypes from 'prop-types'
import Select from './Select'
import { SEARCH, SearchContext } from "../SearchContext"

const _createOptions = (length) => {
  let options = Array.from({ length: length }, (_, i) => {
    return {value: `${i}`, label: `${i} Kids`}
  })
  options[1].label = "1 Kid"
  return options
}

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const filterOptions = (candidate, input) => {
  const escapedValue = escapeRegexCharacters(input.trim())
  const regex = new RegExp('\\b' + escapedValue, 'i')
  if (input) {
    return regex.test(candidate.value)
  }
  return true
}

const SearchKids = ({
  isBookingAgent,
  setKids,
  controlledValue = null,
  optionsLength = 11,
  disabled = false
}) => {

  const { state: { childrenAges }, dispatch } = useContext(SearchContext)
  const _setChildren = (payload) => dispatch({ type: SEARCH.CHILDREN.SET, payload })
  const _setChildrenAges = (payload) => dispatch({ type: SEARCH.CHILDREN_AGES.SET, payload })
  const [options, setOptions] = useState(_createOptions(optionsLength))
  const [value, setValue]     = useState(options[0])

  useEffect(() => {
    if(controlledValue) {
      setValue(options[controlledValue])
    }
  }, [controlledValue])

  useEffect(() => {
    if(optionsLength) {
      setOptions(_createOptions(optionsLength))
    }
  }, [optionsLength])

  const _createArray = (length) => {
    return Array.from({ length: length }, () => "")
  }

  const _handleChange = (selected, action) => {
    let value = action.action == "clear" ? '' : selected
    let children = parseInt(value.value)
    if(setKids) {
      setKids(children)
    } else {
      _setChildren(children)
    }
    setValue(value)
  }

  return (
    <label className="kids children" title="Number of Children" htmlFor="children">
      <div className="fields-icon-wrapper">
        <i className="fas fa-child main-icon" />
        <Select
          name          = "children"
          value         = {value}
          options       = {options}
          defaultValue  = {options[1]}
          filterOption  = {filterOptions}
          handleChange  = {_handleChange}
          isDisabled    = {disabled}
        />
      </div>
    </label>
  )
}

SearchKids.defaultProps = {
  isBookingAgent: false,
  setKids: undefined,
  optionsLength: 11,
  disabled: false
}

SearchKids.propTypes = {
  isBookingAgent: PropTypes.bool,
  setKids: PropTypes.func,
  controlledValue: PropTypes.number,
  optionsLength: PropTypes.number,
  disabled: PropTypes.bool
}

export default SearchKids
